import { render, staticRenderFns } from "./bankdetails.vue?vue&type=template&id=61f7f9d8&scoped=true&"
import script from "./bankdetails.vue?vue&type=script&lang=js&"
export * from "./bankdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f7f9d8",
  null
  
)

export default component.exports